import { render, staticRenderFns } from "./Repayment.vue?vue&type=template&id=12b16b45&scoped=true"
import script from "./Repayment.vue?vue&type=script&lang=js"
export * from "./Repayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b16b45",
  null
  
)

export default component.exports